export default __webpack_public_path__ + "static/media/lifesatisfaction5Img2.b2ce0a79.png";